module.exports = __webpack_public_path__ + "img/Google.a8979bfc.svg";